import React from 'react';

type YouTubeProps = {
   id: string;
   channel?: boolean;
}

const YouTube: React.FC<YouTubeProps> = ({ id, channel }) => (
   <div className="relative h-0 mx-auto max-w-xl" style={{ paddingBottom: "56.25%", width: "95vw" }}>
      <iframe
         className='video m-0 p-0 absolute top-0 left-0 w-full h-full'
         width="640" height="360"
         title='Youtube player'
         src={
            channel
               ? `https://youtube.com/embed/?listType=user_uploads&list=${id}`
               : `https://youtube.com/embed/${id}?autoplay=0`
         }
      >
      </iframe>
   </div>
)

export default YouTube;